import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sprout, Loader2 } from "lucide-react";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth-context";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const m = await login(email, password);
      toast.success(`Selamat datang, ${m.owner_name}!`);
      navigate(m.onboarded ? "/dashboard" : "/onboarding");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login gagal");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="hidden md:flex bg-emerald-600 text-white p-12 flex-col justify-between relative overflow-hidden">
        <div className="absolute inset-0 opacity-10" style={{ backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)", backgroundSize: "24px 24px" }} />
        <div className="relative">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="h-10 w-10 rounded-lg bg-white/20 backdrop-blur flex items-center justify-center">
              <Sprout className="text-white" strokeWidth={2.5} />
            </div>
            <span className="font-heading font-bold text-xl">Custora</span>
          </Link>
        </div>
        <div className="relative">
          <h2 className="font-heading text-3xl lg:text-4xl font-bold leading-tight">
            "Marketplace untuk akuisisi.<br />
            Custora untuk retensi."
          </h2>
          <p className="mt-4 text-emerald-50 text-sm">
            Bergabung dengan 1.200+ UMKM Indonesia yang sudah memiliki database pelanggan sendiri.
          </p>
        </div>
        <div className="relative text-xs text-emerald-100">© 2026 Custora</div>
      </div>

      <div className="flex items-center justify-center p-6 sm:p-12 bg-white">
        <div className="w-full max-w-md">
          <div className="md:hidden mb-8"><Logo /></div>
          <h1 className="font-heading text-3xl font-bold text-gray-900">Masuk ke akun Anda</h1>
          <p className="mt-2 text-gray-600 text-sm">Kelola database pelanggan, campaign, dan repeat order Anda.</p>

          <form onSubmit={submit} className="mt-8 space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                placeholder="owner@brand.com" className="mt-1.5 h-11"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <Label htmlFor="password">Password</Label>
                <button type="button" className="text-xs text-emerald-600 hover:underline">Lupa password?</button>
              </div>
              <Input
                id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="Minimal 6 karakter" className="mt-1.5 h-11"
                data-testid="login-password-input"
              />
            </div>
            <Button
              type="submit" disabled={loading}
              className="w-full h-11 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold"
              data-testid="login-submit-button"
            >
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Masuk
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-600">
            Belum punya akun?{" "}
            <Link to="/signup" className="text-emerald-600 font-semibold hover:underline" data-testid="login-to-signup-link">
              Daftar gratis
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
